<template>
    <Breadcrumbs main="Ui Kits" title="Alert" />
    <div class="container-fluid">
        <div class="row">
            <darkColor />
            <lightClor />
            <textAlert />
            <alertsSection />
            <additionalContent />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const darkColor = defineAsyncComponent(() => import("@/components/theme/uikits/alert/darkColor.vue"))
const lightClor = defineAsyncComponent(() => import("@/components/theme/uikits/alert/lightClor.vue"))
const textAlert = defineAsyncComponent(() => import("@/components/theme/uikits/alert/textAlert.vue"))
const alertsSection = defineAsyncComponent(() => import("@/components/theme/uikits/alert/alertsSection.vue"))
const additionalContent = defineAsyncComponent(() => import("@/components/theme/uikits/alert/additionalContent.vue"))
</script>